<template>
  <div>
    <img class="absolute z-0 left-0 top-0 right-0 w-full h-[844px] md:h-[1080px] object-cover" src="@/assets/images/pos.webp" />
    <div class="relative z-10 w-full h-[calc(844px-124px)] md:h-[calc(1080px-138px)] px-4 py-16">
      <div class="w-full md:w-[60%] md:m-10 p-4 md:p-10 bg-white bg-opacity-60 rounded-3xl">
        <h2 class="uppercase">TurboCash: schnell kassieren</h2>
        <p>Das TurboCash Kassensystem ist in zwei Ausführungen erhältlich. Das Modell "STARTER" ist ein solides Kassensystem mit einem 15.6" Touch-Bildschirm und einem 80 mm Belegdrucker. Das Modell "PRO" enthält darüber hinaus eine Kassenschublade und eine zweizeilige Kundenanzeige. Die Hardware lässt sich frei kombinieren. Vereinbaren Sie einen unverbindlichen Termin, um herauszufinden, welches Modell zu Ihren Bedürfnissen passt.</p>

        <VaRadio
          class="custom-radio radio-flex my-8"
          @update:model-value="clickProduct"
          :options="[
            { text: 'TurboCash STARTER', value: 'starter' },
            { text: 'TurboCash PRO', value: 'pro' },
          ]"
          value-by="value"
        />
      </div>
    </div>

    <div ref="productSegment" class="z-20 relative -mt-6 bg-white rounded-t-3xl p-8 pb-16">
      <div v-if="product === 'starter'" class="flex flex-col md:flex-row gap-32">
        <div class="grow">
          <h2>TurboCash STARTER: schnell und komfortabel kassieren</h2>
          <p>Dieses solide Kassensystem enthält das Wichtigste, um schnell und kostengünstig Verkäufe in der Kasse zu registrieren: ein grosszügiger 15.6 Zoll Touchscreen, eine einfach zu bedienende Bedienungsoberfläche und ein Drucker für 80 mm breite Kassenbons.</p>
          <p>TurboCash STARTER eignet sich besonders gut, wenn der Kunde nicht direkt an der Kasse bezahlt und ein Portemonnaie für das Bargeld benutzt wird. Diese Variante passt gut in Restaurants und Bars, wird aber auch häufig in Dienstleistungsbetrieben genutzt.</p>
          <p><a href="/pdf/datenblatt-turbocash-starter.pdf">Technisches Datenblatt herunterladen</a></p>
          <h2>Aktions-Angebot</h2>
          <p>Bei TurboCash sehen sie den Preis direkt auf der Webseite. Es kommen keine versteckten Zusatzkosten hinzu.</p>
          <p>TurboCash STARTER Aktionspreis: Fr. 70.‒ (zzgl. MwSt.) <span class="line-through red-600">pro Monat statt Fr. 79.‒</span></p>
          <p>Für 24 Monate, danach monatlich Fr. 20.‒ Support-Gebühr und TurboCash Software-Lizenz (zzgl. MwSt.)</p>
        </div>
        <div class="w-full md:w-1/3 shrink-0">
          <img src="@/assets/images/starter.webp" />
        </div>
      </div>

      <div v-if="product === 'pro'" class="flex flex-col md:flex-row gap-32">
        <div class="grow">
          <h2>TurboCash PRO: schnell und komfortabel kassieren</h2>
          <p>Dieses All-in-One Kassensystem enthält alles, was man braucht, um schnell mit dem Kassieren loszulegen: ein grosszügiger 15.6 Zoll Touchscreen, eine einfach zu bedienende Bedienungsoberfläche, ein Drucker für 80 mm breite Kassenbons und eine Kassenschublade für Noten und Münzen sowie eine zweizeilige Kundenanzeige.</p>
          <p>TurboCash PRO eignet sich besonders gut, wenn Kunden direkt an der Kasse bezahlen und die Kassenschublade für das Bargeld benutzt wird. Diese Variante passt gut in den Einzelhandel, wird abar auch häufig von Take Aways und Dienstleistungsbetrieben genutzt.</p>
          <p><a href="/pdf/datenblatt-turbocash-pro.pdf">Technisches Datenblatt herunterladen</a></p>
          <h2>Aktions-Angebot</h2>
          <p>Bei TurboCash sehen sie den Preis direkt auf der Webseite. Es kommen keine versteckten Zusatzkosten hinzu.</p>
          <p>TurboCash STARTER Aktionspreis: Fr. 88.‒ pro Monat (zzgl. MwSt.) <span class="line-through red-600">statt Fr. 99.‒</span></p>
          <p>Für 24 Monate, danach monatlich Fr. 25.‒ Support-Gebühr und TurboCash Software-Lizenz (zzgl. MwSt.)</p>
        </div>
        <div class="w-full md:w-1/3 shrink-0">
          <img src="@/assets/images/pro.webp" />
        </div>
      </div>

      <div>
        <VaButton preset="secondary" border-color="black" color="black" round class="md:w-auto h-[68px] mt-8 !py-2.5 !pl-2.5 !pr-0" :to="{ name: 'appointment' }">
          <span class="ml-2.5">{{ t('common.bookDemo') }}</span>
          <div class="ml-5 w-[46px] h-[46px] rounded-full bg-red-600 flex flex-col items-center justify-center">
            <ArrowRight class="w-4" />
          </div>
        </VaButton>
      </div>
    </div>

    <div class="z-30 relative -mt-6 bg-neutral-200 rounded-t-3xl p-8 pb-16">
      <h2>Sofort betriebsbereit und einfach zu bedienen</h2>
      <p>Wie eine klassische Registrierkasse, ist TurboCash nach dem Anschliessen sofort betriebsbereit. Anders als eine herkömmliche Kasse bietet TurboCash moderne Funktionen und eine einfache Bedienungsoberfläche. Die Kassenbildschirm von TurboCash wurde so gestaltet, dass keine unnötigen Bedienungsschritte anfallen. Die Oberfläche ist übersichtlich und logisch angeordnet und erleichtert die tägliche Arbeit.</p>

      <h2>Ergonomisch von A bis Z</h2>
      <p>TurboCash verfügt über einen grosszügigen 15.6 Zoll Touch-Bildschirm. Dieser hat eine hohe Leuchtkraft und ist bei allen Lichtverhältnissen gut einsehbar. Das Gerät ist an zwei Gelenken verstellbar für den höchsten Komfort.</p>
      <p>Der Kassenbildschirm ist in vier logische Schritte eingeteilt, ein hin und her auf verschiedenen Ansichten entfällt. Ein klarer Ablauf vereinfacht die Bedienung.</p>

      <h2>Erstklassiger Kundendienst</h2>
      <p>Der TurboCash Kundendienst hilft ihnen schnell: dank dem Online-Supportsystem können wir ihnen in den meisten Fällen direkt online helfen. Der Kundendienst verbindet sich über einge sichere Verbindung direkt mit ihrem Gerät und unterstützt sie schnell, ohne dass sie auf den Besuch eines Technikers warten müssen. Zudem ist die Hardware durch eine Garantie von 24 Monaten und einen schnellen Austauschservice gut geschützt.</p>

      <div>
        <VaButton preset="secondary" border-color="black" color="black" round class="md:w-auto h-[68px] mt-8 !py-2.5 !pl-2.5 !pr-0" :to="{ name: 'contact' }">
          <span class="ml-2.5">{{ t('common.contactUs') }}</span>
          <div class="ml-5 w-[46px] h-[46px] rounded-full bg-red-600 flex flex-col items-center justify-center">
            <ArrowRight class="w-4" />
          </div>
        </VaButton>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { VaButton, VaRadio } from 'vuestic-ui'
import { computed, nextTick, onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import Config from '@/utils/config'
import ArrowRight from '@/assets/icons/arrow-right.svg'
import { useI18n } from 'vue-i18n'
import { useMeta } from '@/composables/Meta'

const productSegment = ref()
const route = useRoute()
const router = useRouter()
const { updateMetaData } = useMeta()
const { t } = useI18n()

onMounted(() => {
  updateMetaData({
    title: computed(() => t(`products.seo.${product.value}.title`)),
    description: computed(() => t(`products.seo.${product.value}.description`)),
  })
})

const clickProduct = (value: string) => {
  router.push({ name: 'products', params: { product: value } })
}

const productParam = computed(() => route.params.product as string ?? '')
const product = computed(() => productParam.value ? productParam.value : 'pro')

watch(productParam, (value: string) => {
  if (!value) return
  if (Config.ssr) return
  nextTick(() => {
    productSegment.value.scrollIntoView({ behavior: 'smooth' })
  })
}, { immediate: true })
</script>